module.exports = __webpack_public_path__ + "img/rating-icon.c32474f4.svg";